import React from "react";
import PropTypes from "prop-types";
import "../Button.scss";

/**
 * Uniwersalny przycisk <a> jako komponent React.
 *
 * @param {string[]} classes - Tablica klas CSS.
 * @param {string} text - Tekst wyświetlany na przycisku.
 * @param {string} href - Link do przekierowania.
 * @param iconClasses
 * @param {string} rel - Opcjonalny atrybut rel (domyślnie "noopener noreferrer").
 * @param {string} target - Opcjonalny atrybut target (np. "_self").
 * @param hasIcon check if button hasIcon
 * @param onClick - Funkcja obsługi kliknięcia (opcjonalna).
 * @returns {JSX.Element}
 */
const ButtonLink = ({
                        classes = [],
                        text,
                        href,
                        hasIcon = false,
                        iconClasses = [],
                        rel = "noopener noreferrer",
                        target = "_self",
                        onClick, // Dodaj obsługę onClick
                    }) => {
    // Połączenie klas z tablicy w jeden string
    const className = classes.join(" ");
    return (
        <a
            href={href}
            className={className}
            rel={rel}
            target={target}
            onClick={(e) => {
                if (onClick) {
                    e.preventDefault(); // Zapobiega domyślnemu zachowaniu, jeśli obsługujemy zdarzenie
                    onClick(e);
                }
            }}
        >
            {hasIcon && <span className={`btn-icon ${iconClasses}`}></span>}
            {text}
        </a>
    );
};

ButtonLink.propTypes = {
    classes: PropTypes.arrayOf(PropTypes.string), // Tablica klas CSS
    text: PropTypes.string.isRequired,          // Tekst wyświetlany w przycisku
    href: PropTypes.string.isRequired,          // Adres URL
    rel: PropTypes.string,                      // Atrybut rel
    target: PropTypes.string,                   // Atrybut target
    hasIcon: PropTypes.bool,                    // Czy przycisk ma ikonę
    iconClasses: PropTypes.arrayOf(PropTypes.string), // Klasy CSS ikony
    onClick: PropTypes.func,                    // Funkcja obsługi kliknięcia
};

export default ButtonLink;
